import React, { useEffect, useState } from 'react';

import { Accordion } from '@radix-ui/react-accordion';
import { useMeasure } from 'react-use';

import { GroupFilterSpam } from '@pkg/components';

import { useWindowResize } from '@app/helpers';

import { GroupFilterCollections } from './GroupFilterCollections';
import { GroupFilterMembers } from './GroupFilterMembers';
import { GroupFilterOwnership } from './GroupFilterOwnership';

// TODO: Investigate why this component requires a `height` set by JavaScript?
const GROUP_FILTERS_MIN_HEIGHT = 160;

export const GroupFilters = () => {
    const [parentHeight, setParentHeight] = useState(0);
    const [remainingHeight, setRemainingHeight] = useState(0);

    const [childrenRef, { height: childrenHeight }] = useMeasure<HTMLDivElement>();
    const windowSize = useWindowResize();

    useEffect(() => {
        setParentHeight(windowSize.height || 0);
    }, [windowSize]);

    useEffect(() => {
        if (parentHeight !== 0) {
            const finalHeight = Math.max(parentHeight - childrenHeight - 105, GROUP_FILTERS_MIN_HEIGHT);

            setRemainingHeight(finalHeight);
        }
    }, [parentHeight, childrenHeight]);

    return (
        <Accordion id="group-filters" type="multiple" defaultValue={['0', '1', '2', '3']}>
            <div ref={childrenRef}>
                {/*TODO - update all uses to use value*/}
                <GroupFilterSpam index={'0'} />
                <GroupFilterOwnership value={'1'} />
                <GroupFilterMembers value={'2'} />
            </div>

            <GroupFilterCollections value={'3'} height={remainingHeight} />
        </Accordion>
    );
};
